import type { FC } from 'react';
import { useCallback, useState } from 'react';
import BooleanInput from '@wix/da-ds/pkg/formControls/dsPresets/BooleanInput';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '@wix/da-shared-react/pkg/Popup/ConfirmationModal';
import {
  confirmNo,
  confirmYes,
} from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { Alert as AlertIllustration } from '@wix/da-ds/pkg/Icons/Confirmations/Alert';
import s from './SellPrivateExclusiveConfirmation.scss';

interface Props {}

const SellPrivateExclusiveConfirmation: FC<Props> = () => {
  const { t } = useTranslation();
  const [hasOwnerConsent, setHasOwnerConsent] = useState(false);
  const dispatchConfirmYes = useAction(confirmYes);
  const dispatchConfirmNo = useAction(confirmNo);
  const handleOwnerConsentChange = useCallback((value: boolean) => {
    setHasOwnerConsent(value);
  }, []);

  const handleCancel = useCallback(() => {
    dispatchConfirmNo();
  }, [dispatchConfirmNo]);

  return (
    <ConfirmationModal
      icon={<AlertIllustration />}
      title={t('studio.modals.submitPrivateConfirmation.title')}
      variant="vertical"
      text={
        <div>
          {t('studio.modals.submitPrivateConfirmation.text')}
          <BooleanInput
            type="checkbox"
            size="small"
            id="owner-permission"
            value={hasOwnerConsent}
            className={s['checkbox']}
            label={t('studio.modals.submitPrivateConfirmation.checkbox.label')}
            labelClassName={s['checkbox-label']}
            onChange={handleOwnerConsentChange}
          />
        </div>
      }
      confirmBtnLabel={t('studio.modals.submitPrivateConfirmation.confirmBtn')}
      cancelBtnLabel={t('common.cancel')}
      confirmBtnDisabled={!hasOwnerConsent}
      onConfirm={dispatchConfirmYes}
      onCancel={dispatchConfirmNo}
      onRequestClose={handleCancel}
      isOpen
    />
  );
};

SellPrivateExclusiveConfirmation.displayName =
  'SellPrivateExclusiveConfirmation';

export default SellPrivateExclusiveConfirmation;
